import { Box } from "@mui/material";
import InlineText, { InlineTextContainer } from "src/components/InlineText";
import StudentTabContainer from "./sections/StudentTabContainer.section";
// ----------------------------------------------------------------------

export default function DetailsPage({ student }) {
  const sessionInfo =
    `${student?.session_type || ""} ${student?.session_value || ""}`.trim() ||
    "-";

  return (
    <StudentTabContainer title={`${student?.first_name}'s Details`}>
      <Box
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
        }}
      >
        <InlineTextContainer>
          <InlineText tag="Email Id" value={student?.email ?? "-"} />
          <InlineText tag="DOB" value={student?.date_of_birth ?? "-"} />
          <InlineText tag="Age" value={student?.age ?? "-"} />
          <InlineText tag="Gender" value={student?.gender ?? "-"} />
          <InlineText tag="School" value={student?.school_name ?? "-"} />
        </InlineTextContainer>
        <InlineTextContainer>
          <InlineText tag="Curriculum" value={student?.curriculum ?? "-"} />
          <InlineText tag="Grade/Year" value={sessionInfo ?? "-"} />
          <InlineText tag="Mode" value={student?.mode ?? "-" ?? "-"} />
          <InlineText
            tag="Parent Name"
            value={student?.parent_id?.name ?? "-"}
          />
        </InlineTextContainer>
      </Box>
    </StudentTabContainer>
  );
}
